import { GetCommentRes } from "../../services";

export const commentData_3: GetCommentRes[] = [
  {
    brandName: "아디다스",
    couponName: "아디다스 아디케인 플리플랍",
    comment: "진작 쓸 걸 그랬네요",
  },
  {
    brandName: "스타벅스",
    couponName: "자비칩 프라푸치노",
    comment: "쿠폰 덕분에 싸게 이용할 수 있어서 좋았어요",
  },
  {
    brandName: "나이키",
    couponName: "나이키 포워드 재켓",
    comment:
      "학생이라 조금 부담됐었는데, 덕분에 싸게 살 수 있었어요. 다음에도 또 이용할게요!",
  },
];

export const commentData_6: GetCommentRes[] = [
  {
    brandName: "아디다스",
    couponName: "아디다스 아디케인 플리플랍",
    comment: "진작 쓸 걸 그랬네요",
  },
  {
    brandName: "스타벅스",
    couponName: "자비칩 프라푸치노",
    comment: "쿠폰 덕분에 싸게 이용할 수 있어서 좋았어요",
  },
  {
    brandName: "나이키",
    couponName: "나이키 포워드 재켓",
    comment:
      "학생이라 조금 부담됐었는데, 덕분에 싸게 살 수 있었어요. 다음에도 또 이용할게요!",
  },
  {
    brandName: "아디다스",
    couponName: "아디다스 아디케인 플리플랍",
    comment: "진작 쓸 걸 그랬네요",
  },
  {
    brandName: "스타벅스",
    couponName: "자비칩 프라푸치노",
    comment: "쿠폰 덕분에 싸게 이용할 수 있어서 좋았어요",
  },
  {
    brandName: "나이키",
    couponName: "나이키 포워드 재켓",
    comment:
      "학생이라 조금 부담됐었는데, 덕분에 싸게 살 수 있었어요. 다음에도 또 이용할게요!",
  },
];
